/*
 *
 * Announcement reducer
 *
 */

import {LOAD_ANNOUNCEMENT_SUCCESS, REMOVE_ANNOUNCEMENT} from './constants';


function announcementReducer(state = {}, {type, payload}) {
    switch (type) {
        case LOAD_ANNOUNCEMENT_SUCCESS:
            return state.data = payload

        case REMOVE_ANNOUNCEMENT:
            const items = state.data.filter(item => item.id !== payload.id)
            return {data: [...items]}

        default:
            return state;
    }
}

export default announcementReducer;
